var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2549 37.0352C39.7853 38.5123 38.4052 40.0715 36.4471 40.966C34.9226 41.6642 33.2649 42.0171 31.5905 42C28.8507 41.8235 26.2982 40.8429 23.8557 39.6407C14.7247 35.2269 7.26698 27.9378 2.60937 18.8745C1.46136 16.6876 0.435475 14.4144 0.105728 11.8992C-0.370573 8.30068 0.818163 5.26844 3.30551 2.71216C3.94058 2.05566 4.58378 1.41147 5.23107 0.767268C6.28544 -0.270833 7.14849 -0.283142 8.18658 0.767268C10.5043 3.09513 12.8112 5.42026 15.1072 7.74265C16.1209 8.77254 16.1209 9.63831 15.1072 10.6641C13.8289 11.9648 12.5343 13.2532 11.2561 14.5498C9.59512 16.2362 9.47299 17.9924 10.849 19.884C14.1108 24.2988 18.0347 28.1748 22.4797 31.3728C24.2139 32.6038 26.0255 32.4807 27.5358 30.9625C28.8059 29.6864 30.0476 28.3898 31.3137 27.1096C32.3395 26.0715 33.227 26.0715 34.2651 27.1096C36.5828 29.4347 38.8897 31.7599 41.1857 34.085C42.2442 35.1518 42.2523 36.0299 41.2549 37.0352Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneN1);
export default __webpack_public_path__ + "static/media/phone-n-1.1ff0532304cb4ca12d4a0dfe72df7f1e.svg";
export { ForwardRef as ReactComponent };